module.exports = __webpack_public_path__ + "img/4s.bafcc106.png";